module.exports = __webpack_public_path__ + "static/08-navigate-to-problematic-plants-959a0028336b27f7ae487016c687c6fd.png";